import { Button, Group, Image, Stack, TextInput, Title } from '@mantine/core';
import { normalizeOperationOutcome } from '@medplum/core';
import { OperationOutcome } from '@medplum/fhirtypes';
import {
  Document,
  Form,
  getErrorsForInput,
  getIssuesForExpression,
  getRecaptcha,
  initRecaptcha,
  OperationOutcomeAlert,
  useMedplum,
} from '@medplum/react';
import { ReactElement, useEffect, useState } from 'react';
import logoBlack from '../assets/everself_logo_black.png';
import { getConfig } from '../config';

export function ResetPasswordPage(): ReactElement {
  const medplum = useMedplum();
  const [outcome, setOutcome] = useState<OperationOutcome>();
  const [success, setSuccess] = useState(false);
  const recaptchaSiteKey = getConfig().recaptchaSiteKey;
  const projectId = import.meta.env.VITE_MEDPLUM_PROJECT_ID;

  useEffect(() => {
    if (recaptchaSiteKey) {
      initRecaptcha(recaptchaSiteKey);
    }
  }, [recaptchaSiteKey]);

  return (
    <Document width={450}>
      <Form
        onSubmit={async (formData: Record<string, string>) => {
          let recaptchaToken = '';
          if (recaptchaSiteKey) {
            recaptchaToken = await getRecaptcha(recaptchaSiteKey);
          }

          medplum
            .post('auth/resetpassword', {
              ...formData,
              projectId,
              recaptchaToken,
              recaptchaSiteKey,
              sendEmail: false,
            })
            .then(() => setSuccess(true))
            .catch((err) => setOutcome(normalizeOperationOutcome(err)));
        }}
      >
        <Stack mb="xl" align="center">
          <Image src={logoBlack} alt="Everself Logo" w={180} />
          <Title fz="xl">Reset your password</Title>
        </Stack>
        <Stack gap="xl">
          <OperationOutcomeAlert issues={getIssuesForExpression(outcome, undefined)} />
          {!success && (
            <>
              <TextInput
                name="email"
                type="email"
                label="Email"
                required={true}
                autoFocus={true}
                error={getErrorsForInput(outcome, 'email')}
              />
              <Group justify="flex-end" mt="xl" wrap="nowrap">
                <Button type="submit" bg="#243622">
                  Reset password
                </Button>
              </Group>
            </>
          )}
          {success && <div>If we recognize that email, we'll send reset instructions.</div>}
        </Stack>
      </Form>
    </Document>
  );
}
